export enum Status {
  All = '#/',
  Active = '#/active',
  Completed = '#/completed',
}
